import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import "./intermediary.scss"
import Text from '../../components/typography/typgraphy';
import { useSelector, useDispatch } from "react-redux";
import { APP_URLS } from '../../constants/constants';
import { getTransactionIdFromURL } from '../../constants/utils';
import success from '../../assets/images/otpVerified.svg';
import { perfiosCompleteApi } from '../../core/actionCreators/perfiosCompleteActionCreator';
import { PERFIOS_INTERMEDIARY_PAGELOAD_PARAM, PERFIOS_INTERMEDIARY_PAGELOAD_VPV, pushDataLayer } from '../../constants/gaConstants';

const Intermediary = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const transactionId = getTransactionIdFromURL()
    const completeDetails = useSelector(state => state.perfiosComplete);
    const partnerData = useSelector(state => state.auth);
    const transactionDetails = useSelector(state => state.transactionDetails);

    useEffect(() => {
      pushDataLayer(PERFIOS_INTERMEDIARY_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, transactionId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      pushDataLayer(PERFIOS_INTERMEDIARY_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, transactionId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

      dispatch(perfiosCompleteApi())
    },[])

    useEffect(() => {
        if (completeDetails.perfios_complete_code == 6000) {
          history.push(`${APP_URLS.SUCCESS.replace(":txnId", transactionId)}`);
        }
        else if (completeDetails.perfios_complete_code == 8505){
          history.push({
            pathname: `${APP_URLS.ERROR.replace(":txnId", transactionId)}`,
            state: { errorCode: completeDetails.perfios_complete_code }
          })
        }
        else if (completeDetails.perfios_complete_code == 8510){ //API timeout handling
          history.push({
            pathname: `${APP_URLS.SUCCESS.replace(":txnId", transactionId)}`,
            state: { errorCode: completeDetails.perfios_complete_code }
          })
        }
      }, [completeDetails, history, transactionId])

    return(
        <Fragment>
            <div className='verified'>
                <div className='verified__icon'><img src={success}/></div>
                <div className='verified__text'>Validation Successful</div>
                <div className='verified__status-text'>Fetching transaction status</div>
            </div>
        </Fragment>
    )
}

export default Intermediary;